import { Outlet } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { AnnouncementBanner } from '../AnnouncementBanner'

/**
 * App shell layout with persistent sidebar and main content area.
 */
export function AppLayout() {

  return (
    <div className="flex h-screen overflow-hidden">
      <Sidebar />

      <div className="flex flex-col flex-1 md:ml-60 transition-all duration-200 overflow-hidden">
        <AnnouncementBanner />

        {/* Main Content Area */}
        <main className="flex-1 overflow-y-auto bg-white">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
